module.exports = __webpack_public_path__ + "img/icon-2.6bea9326.svg";